import SecureLS from 'secure-ls';

export const secureLocalStore = new SecureLS({ encodingType: 'aes-256-cbc', isCompression: false });
